import React from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import {routes} from "../Routes";
import Loader from "../../components/Loader";
import DocumentsUpload from "../../views/documents/DocumentsUpload";
import CustomersList from "../../views/customer/CustomersList";
import {AdviceView} from "../../views/advice/AdviceView";
import {CustomerBillingPlan} from "../../views/billing/CustomerBillingPlan";
import {MyCompanyInfo} from "../../views/companies/MyCompanyInfo";
import {KnowledgeBaseInfo} from "../../views/knowledge/KnowledgeBaseInfo";
import {useSalesInvoiceRoutes} from "../SalesInvoiceRoutes";
import AddEmployee from "../../views/employee/new/NewEmployeeWizard";
import {ClientDocsTemplate} from "../../views/knowledge/ClientDocsTemplate";
import CompanySettings from "../../views/companies/CompanySettings";
import {selectedCompanyStore} from "../../store/SelectedCompany";
import {useRouteWithParam} from "../../components/RouteWithParam";
import {OpenDocsTemplate} from "../../views/knowledge/OpenDocsTemplate";

export default function ClientRoutes() {
    return <>
        <Routes>
            <Route path={routes.documentsUpload} element={<DocumentsUpload/>}/>

            <Route path={routes.companySettings} element={<CompanySettings companyId={selectedCompanyStore.companyId}/>}/>

            <Route path={routes.billing} element={<CustomerBillingPlan/>}/>
            <Route path={routes.advice} element={<AdviceView/>}/>
            <Route path={routes.myClients} element={<CustomersList/>}/>

            <Route path={routes.addEmployee} element={<AddEmployee/>}/>
            <Route path={routes.myCompany} element={<MyCompanyInfo/>}/>

            <Route path={routes.knowledgeBase} element={<KnowledgeBaseInfo/>}/>

            <Route path={routes.clientDocsTemplates} element={<ClientDocsTemplate/>}/>
            {useRouteWithParam({
                path: routes.clientDocsTemplatesOpen,
                render: params => <OpenDocsTemplate templateId={params.templateId}/>
            })}

            {useSalesInvoiceRoutes()}

            <Route path="/temp" element={<Loader loading={true}/>}/>
            <Route path="/" element={<Navigate to={routes.documentsUpload} replace/>}/>
        </Routes>
    </>;
}
